import Header from "~/components/ui/SectionHeader"
import type { ImageWidget } from "~/types/widgets"

/**
 * @titleBy alt
 */
export interface Banner {
    /**
     * @title Imagem
     */
    src: ImageWidget
    /**
     * @title Texto alternativo
     */
    alt: string
    /**
     * @title Link
     */
    href: string
}

export interface Props {
    /**
     * @title Título
     */
    title?: string
    /**
     * @title Descrição
     */
    description?: string
    /**
     * @title Banners da esquerda
     * @maxItems 2
     * @minItems 2
     */
    bannerLeft: Banner[]
    /**
     * @title Banners da direita
     * @maxItems 2
     * @minItems 2
     */
    bannerRight: Banner[]
    /**
     * @title Banner do centro
     */
    bannerCenter: Banner
}

const DEFAULT_PROPS: Props = {
    bannerLeft: [
        {
            src: 'https://miess.vteximg.com.br/arquivos/ids/309161/bannerfantis.jpg?v=638313440387570000',
            alt: 'Fashion',
            href: '/',
        },
        {
            src: 'https://miess.vteximg.com.br/arquivos/ids/309162/bannerfetichee.jpg?v=638313428271900000',
            alt: 'Fashion',
            href: '/',
        },
    ],
    bannerRight: [
        {
            src: 'https://miess.vteximg.com.br/arquivos/ids/309164/bannervibro.jpg?v=638313428752200000',
            alt: 'Fashion',
            href: '/',
        },
        {
            src: 'https://miess.vteximg.com.br/arquivos/ids/309165/bannercosmeticos.jpg?v=638313429117830000',
            alt: 'Fashion',
            href: '/',
        },
    ],
    bannerCenter: {
        src: 'https://miess.vteximg.com.br/arquivos/ids/309163/bannerling.jpg?v=638313428481900000',
        href: '/',
        alt: 'Fashion',
    },
}

export default function ImageGalleryCenter(props: Props) {
    const { bannerLeft, bannerRight, bannerCenter, title, description } = {
        ...DEFAULT_PROPS,
        ...props,
    }

    return (
        <section className='container px-4 py-8 flex flex-col gap-8 gap-10 py-10 px-0'>
            <Header title={title} description={description} alignment='center' />
            <div className='container grid grid-cols-3 grid-rows-[0.9fr 1.1fr] grid-flow-row gap-0 md:grid md:grid-cols-3 md:grid-rows-[0.9fr 1.1fr] md:grid-flow-row gap-0 sm:grid sm:grid-cols-1 sm:grid-rows-[0.9fr 1.1fr 1fr 1fr 1fr 1fr] sm:grid-flow-row gap-0'>
                {bannerLeft.map((banner, index) => {
                    return (
                        <>
                            {index === 0
                                ? (
                                    <>
                                        <div className='col-span-1 row-span-1 md:col-span-1 md:row-span-1 sm:col-span-1 sm:row-span-1'>
                                            <a href={banner.href}>
                                                <img
                                                    className='float-left opacity-100 h-auto max-w-full filterGrayscale pointer'
                                                    style={{transition: 'all .5s ease-in-out', border: 'none'}}
                                                    id={banner.alt}
                                                    alt={banner.alt}
                                                    data-src={banner.src}
                                                    src={banner.src}
                                                    loading='lazy'
                                                />
                                            </a>
                                        </div>
                                        <div className='hidden lg:flex col-span-1 row-span-1 md:col-span-1 md:row-span-2 sm:col-span-1 sm:row-span-2'>
                                            <a href={bannerCenter.href}>
                                                <img
                                                    className='float-left opacity-100 h-auto max-w-full filterGrayscale pointer'
                                                    style={{transition: 'all .5s ease-in-out', border: 'none'}}
                                                    id={bannerCenter.alt}
                                                    alt={bannerCenter.alt}
                                                    data-src={bannerCenter.src}
                                                    src={bannerCenter.src}
                                                    loading='lazy'
                                                />
                                            </a>
                                        </div>
                                    </>
                                )
                                : (
                                    <div className='col-span-1 row-span-2 md:col-span-1 md:row-span-1 sm:col-span-1 sm:row-span-1'>
                                        <a href={banner.href}>
                                            <img
                                                className='float-left opacity-100 h-auto max-w-full filterGrayscale pointer'
                                                style={{transition: 'all .5s ease-in-out', border: 'none'}}
                                                id={banner.alt}
                                                alt={banner.alt}
                                                data-src={banner.src}
                                                src={banner.src}
                                                loading='lazy'
                                            />
                                        </a>
                                    </div>
                                )}
                        </>
                    )
                })}

                <div className='flex lg:hidden col-span-1 row-span-2 md:col-span-1 md:row-span-2 sm:col-span-1 sm:row-span-2'>
                    <a href={bannerCenter.href}>
                        <img
                            className='float-left opacity-100 h-auto max-w-full filterGrayscale pointer'
                            style={{transition: 'all .5s ease-in-out', border: 'none'}}
                            id={bannerCenter.alt}
                            alt={bannerCenter.alt}
                            data-src={bannerCenter.src}
                            src={bannerCenter.src}
                            loading='lazy'
                        />
                    </a>
                </div>

                {bannerRight.map((banner) => (
                    <div className='col-span-1 row-span-1 md:col-span-1 md:row-span-1 sm:col-span-1 sm:row-span-2'>
                        <a href={banner.href}>
                            <img
                                className='float-left opacity-100 h-auto max-w-full filterGrayscale pointer'
                                style={{transition: 'all .5s ease-in-out', border: 'none'}}
                                id={banner.alt}
                                alt={banner.alt}
                                data-src={banner.src}
                                src={banner.src}
                                loading='lazy'
                            />
                        </a>
                    </div>
                ))}
            </div>
        </section>
    )
}
export { default as LoadingFallback } from "~/components/LoadingFallback"
